import { BodyThree, HeadlineFive, OverlineSix, OverlineThree } from '@nucleus/ncu-section-builder';
import { ListItemApi } from '@nucleus/types/web';

export const ListItemDefaults: Partial<ListItemApi> = {
  overline: OverlineSix({ children: '' }),
  headline: HeadlineFive({ children: '' }),
  byline: OverlineThree({ children: '' }),
  body: BodyThree({ children: '' }),
  actions: [],
  mediaItems: [],
};
